import Service, {
  setUserSelectedMicrophone,
} from '/imports/ui/components/audio/service';

export const joinMicrophone = (options = {}) => {
  const { skipEchoTest = false } = options;
  const shouldSkipEcho = skipEchoTest && Service.inputDeviceId() !== 'listen-only';

  setUserSelectedMicrophone(true);

  const {
    enabled: LOCAL_ECHO_TEST_ENABLED,
  } = window.meetingClientSettings.public.media.localEchoTest;

  const call = new Promise((resolve, reject) => {
    try {
      if ((shouldSkipEcho && !Service.isConnected()) || LOCAL_ECHO_TEST_ENABLED) {
        return resolve(Service.joinMicrophone(options));
      }

      return resolve(Service.transferCall());
    } catch {
      return reject(Service.exitAudio);
    }
  });

  return call.then(() => {
    document.dispatchEvent(new Event("CLOSE_MODAL_AUDIO"));
  }).catch((error) => {
    throw error;
  });
};

export const leaveEchoTest = () => {
  if (!Service.isEchoTest()) {
    return Promise.resolve();
  }
  return Service.exitAudio();
};

export const closeModal = (callback) => {
  const { allowAudioJoinCancel: ALLOW_AUDIO_JOIN_CANCEL } = window
    .meetingClientSettings.public.media.audio;

  if (Service.isConnecting()) {
    if (!ALLOW_AUDIO_JOIN_CANCEL) return;

    Service.forceExitAudio();
  }

  callback();
};

const getTroubleshootingLink = (errorCode) => {
  const TROUBLESHOOTING_LINKS = window.meetingClientSettings.public.media.audioTroubleshootingLinks;

  if (TROUBLESHOOTING_LINKS) return TROUBLESHOOTING_LINKS[errorCode] || TROUBLESHOOTING_LINKS[0];
  return null;
};

export default {
  joinMicrophone,
  closeModal,
  leaveEchoTest,
  getTroubleshootingLink,
};
